import { visitorCountry } from "./visitor-country";
import { t } from "../i18n";

//The checkouts carry a static country select baked from the offer's CRM
//allowlist (scripts/bake-country-select.mjs). When the transaction check
//brings the current allowlist, the baked options are reconciled against it,
//so an allowlist change in the CRM reaches pages whose HTML has not been
//re-baked yet. Pages still carrying the old hidden country input get it
//replaced with a freshly built select - the pre-bake behavior, kept as a
//safety net for cloned or not-yet-migrated landings. Option values are the
//ISO codes save-data expects.
export function countrySelect(countries) {
	if (!Array.isArray(countries) || !countries.length) {
		return;
	}

	document
		.querySelectorAll('.sdk-form select[name="country"]')
		.forEach((select) => {
			reconcile(select, countries);
		});

	document
		.querySelectorAll('.sdk-form input[name="country"][type="hidden"]')
		.forEach((input) => {
			replaceHiddenInput(input, countries);
		});

	if (countries.length > 1) {
		visitorCountry().then((countryCode) => {
			document
				.querySelectorAll('.sdk-form select[name="country"]')
				.forEach((select) => {
					if (select.value) {
						return;
					}
					const option = Array.from(select.options).find(
						(o) => o.value.toUpperCase() === countryCode,
					);
					if (option) {
						select.value = option.value;
						announce(select);
					}
				});
		});
	}
}

//Whatever this feature writes into the field is written by script, which fires
//no event of its own - and the state list is waiting for exactly that.
function announce(select) {
	select.dispatchEvent(new Event("change", { bubbles: true }));
}

function fillOptions(select, countries) {
	if (countries.length > 1) {
		const placeholder = document.createElement("option");
		placeholder.value = "";
		placeholder.textContent = t("formsPlaceholders").country;
		select.appendChild(placeholder);
	}

	countries.forEach((country) => {
		const option = document.createElement("option");
		option.value = country.iso;
		option.textContent = country.name;
		select.appendChild(option);
	});
}

function reconcile(select, countries) {
	const baked = Array.from(select.options)
		.map((o) => o.value)
		.filter(Boolean)
		.sort()
		.join(",");
	const current = countries
		.map((c) => c.iso)
		.sort()
		.join(",");

	if (baked === current) {
		return;
	}

	const selected = select.value;
	select.innerHTML = "";
	fillOptions(select, countries);

	if (selected && countries.some((c) => c.iso === selected)) {
		select.value = selected;
	}

	announce(select);
}

function replaceHiddenInput(input, countries) {
	const form = input.closest("form");
	const stateSelect = form.querySelector('select[name="state"]');

	const select = document.createElement("select");
	select.name = "country";
	select.required = true;
	if (input.id) {
		select.id = input.id;
	}

	//Borrow the look of a field the landing already styles.
	const styled =
		stateSelect || form.querySelector('input[type="text"], input[type="email"]');
	if (styled && styled.className) {
		select.className = styled.className;
	}

	fillOptions(select, countries);

	//The hidden input sits in the blob of hidden fields at the top of the
	//form; a state dropdown marks the address block, so slot in next to it
	//when there is one.
	if (stateSelect) {
		stateSelect.insertAdjacentElement("beforebegin", select);
		input.remove();
	} else {
		input.replaceWith(select);
	}

	announce(select);
}
